@if (showJobDescription) {
  <div class="content-div" [ngClass]="{'inactive-job': !selectedJob.is_active}">
    <!-- <button class="close-icon" (click)="closeJobDescription()">
      <img src="/assets/icons/close-icon.svg" alt="close" />
    </button> -->
  
    <!-- Header -->
    <div class="header-div">
      <div class="left-header">
        <p class="header-text" [ngClass]="{'inactive-job': !selectedJob.is_active}">{{selectedJob.job_title}}</p>
      </div>
      <div class="right-header-div">
        @if (selectedJob.is_bookmarked) {
         <div class="bookmark-div" [class.disabled]="'bookmark-div-disabled '" (click)="!isBookmarkDisable && onClickJobBookmark(selectedJob.posting_id, 'REMOVE')">
           <img matTooltip="Unbookmark" matTooltipPosition="above" src="/assets/icons/bookmarked.svg" alt="bookmarked-icon" />
           <p class="bookmark-text">Bookmarked</p>
         </div>
        } @else {
         <div class="bookmark-div bookmark-hover" [class.disabled]="'bookmark-div-disabled '" (click)="!isBookmarkDisable && onClickJobBookmark(selectedJob.posting_id, 'ADD')">
           <img matTooltip="Bookmark" matTooltipPosition="above"  src="/assets/icons/bookmark.svg" alt="bookmark-icon" />
         </div>
        }
   
        @if(selectedJob?.job_url && selectedJob.is_active) {
        <div class="right-header">
          <a mat-flat-button class="btn" [href]="selectedJob.job_url" target="_blank" rel="noopener noreferrer"
            [attr.aria-disabled]="!selectedJob?.job_url ? 'true' : null" (click)="trackApplyClick()">
            Apply
            <img src="/assets/icons/external-link-primary.svg" alt="external-link" />
          </a>
        </div>
        }
 
       
      </div>
 
    </div>

    <div class="sub-header-details">
      <div class="sub-header">
          <p class="sub-heading-text">{{ selectedJob.employer_name}}</p>
      </div>
      @if (selectedJob.employment_type || selectedJob.is_internship) {
        <div class="sub-header">
          <img src="/assets/icons/find-job/role-suitcase.svg" alt="role" />
          <p class="sub-heading-text">
            {{ selectedJob.is_internship ? 'Internship' : selectedJob.employment_type | underscoreToLower }}
          </p>
        </div>
      }
      @if (selectedJob.employment_location_type) {
        <div class="sub-header">
          <img src="/assets/icons/find-job/location-map.svg" alt="location" />
          @if(isRemoteJob) {
            <p class="sub-heading-text">{{ selectedJob.location && selectedJob.location !== 'N/A' ? 'Remote-' + selectedJob.location : 'Remote' }}</p>
          } @else {
             <p class="sub-heading-text">{{selectedJob.location}}</p>
          }          
        </div>
      }
      @if (selectedJob.posting_date) {
        <div class="sub-header">
          <img src="/assets/icons/find-job/clock-time.svg" alt="time" />
          @if (selectedJob.is_active) {
            <p class="sub-heading-text">{{ selectedJob.posting_date | timeAgo }}</p>
          } @else {
            <p class="sub-heading-text">No longer available</p>
          }
        </div>
      }
    </div>
  
    <!-- Match Report -->
    <app-match-report [job]="selectedJob"></app-match-report>

    <!-- Job Description -->
    <app-job-description [job]="selectedJob"></app-job-description>
  
    <!-- Qualification -->
    <app-qualification [job]="selectedJob"></app-qualification>
  
  
   
    
  </div>
} @else {
  <div class="default-content-div">
    <div class="default-content">
      <img 
        src="/assets/icons/find-job/job-posting-list.svg" 
        alt="job-posting-icon"
        class="job-posting-icon" 
      />
      <p class="default-text">Click on job postings to <br/> learn more about the role.</p>
    </div>
  </div>
}
